import React from 'react';
import Header24 from './components/Header24';
import Footer24 from './components/Footer24';

const TermsAndConditions24 = () => {
    const sections = [
        {
            title: 'Acceptance of Terms',
            content: 'By accessing and using the Dhara website and services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our website. These terms apply to all visitors, users, and customers who access or use the service.',
        },
        {
            title: 'Products & Availability',
            content: 'All products displayed on our website are subject to availability. We reserve the right to discontinue any product at any time without notice. While we make every effort to display product colours and details accurately, we cannot guarantee that your device\'s display will accurately reflect the actual colours of the products. Due to the handcrafted nature of our pieces, slight variations in colour, texture, and pattern are inherent and are not considered defects.',
        },
        {
            title: 'Pricing & Payment',
            content: 'All prices are listed in Indian Rupees (INR) and are inclusive of applicable taxes unless otherwise stated. We reserve the right to modify prices at any time. Payment is required at the time of ordering. We accept major credit and debit cards, UPI, and net banking. Your payment details are processed through secure, encrypted channels.',
        },
        {
            title: 'Orders & Confirmation',
            content: 'When you place an order, you will receive an email acknowledgment confirming receipt of your order. This acknowledgment does not constitute acceptance. We reserve the right to refuse or cancel any order for any reason, including but not limited to product availability, errors in pricing, or suspected fraudulent activity.',
        },
        {
            title: 'Shipping & Delivery',
            content: 'We ship across India and to select international destinations. Delivery timelines are estimates and may vary depending on your location and other factors. Standard delivery within India takes 5-7 business days. Express delivery is available for select locations. Dhara is not responsible for delays caused by shipping carriers, customs, or events beyond our control.',
        },
        {
            title: 'Returns & Exchanges',
            content: 'We want you to be completely satisfied with your purchase. Items may be returned within 14 days of delivery, provided they are unworn, unwashed, and in their original condition with all tags attached. Custom or made-to-order pieces are not eligible for returns. Please refer to our Shipping & Returns page for complete details.',
        },
        {
            title: 'Intellectual Property',
            content: 'All content on this website, including text, images, graphics, logos, designs, and product photographs, is the property of Dhara and is protected by copyright and intellectual property laws. You may not reproduce, distribute, or use any content without prior written permission from Dhara.',
        },
        {
            title: 'Limitation of Liability',
            content: 'Dhara shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our website or products. Our total liability shall not exceed the purchase price of the product(s) in question. This limitation applies to the fullest extent permitted by applicable law.',
        },
        {
            title: 'Governing Law',
            content: 'These Terms and Conditions are governed by and construed in accordance with the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in New Delhi, India.',
        },
        {
            title: 'Changes to Terms',
            content: 'We reserve the right to update or modify these Terms and Conditions at any time without prior notice. Changes become effective upon posting to this page. Your continued use of the website after changes are posted constitutes acceptance of the revised terms.',
        },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Inter:wght@300;400;500;600;700&display=swap');

                .dhara-terms {
                    min-height: 100vh;
                    background: #FFFFFF;
                }
                .dhara-terms-inner {
                    max-width: 760px;
                    margin: 0 auto;
                    padding: 80px 40px 120px;
                }
                .dhara-terms-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 42px;
                    font-weight: 400;
                    color: #1A1A1A;
                    margin-bottom: 16px;
                    letter-spacing: -0.5px;
                }
                .dhara-terms-updated {
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    color: #6B6B6B;
                    margin-bottom: 60px;
                }
                .dhara-terms-section {
                    margin-bottom: 48px;
                }
                .dhara-terms-section-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 22px;
                    font-weight: 500;
                    color: #1A1A1A;
                    margin-bottom: 16px;
                }
                .dhara-terms-section-text {
                    font-family: 'Inter', sans-serif;
                    font-size: 15px;
                    color: #6B6B6B;
                    line-height: 1.9;
                    font-weight: 300;
                }
                .dhara-terms-contact {
                    margin-top: 60px;
                    padding: 40px;
                    background: #FAFAF8;
                    border: 1px solid #E5E5E5;
                }
                .dhara-terms-contact-title {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    color: #1A1A1A;
                    margin-bottom: 8px;
                }
                .dhara-terms-contact-text {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #6B6B6B;
                    line-height: 1.7;
                }

                @media (max-width: 768px) {
                    .dhara-terms-inner { padding: 40px 20px 80px; }
                    .dhara-terms-title { font-size: 32px; }
                    .dhara-terms-contact { padding: 24px; }
                }
            `}</style>

            <Header24 />

            <main className="dhara-terms">
                <div className="dhara-terms-inner">
                    <h1 className="dhara-terms-title">Terms & Conditions</h1>
                    <p className="dhara-terms-updated">Last updated: March 1, 2026</p>

                    {sections.map((section, i) => (
                        <div key={i} className="dhara-terms-section">
                            <h2 className="dhara-terms-section-title">{section.title}</h2>
                            <p className="dhara-terms-section-text">{section.content}</p>
                        </div>
                    ))}

                    <div className="dhara-terms-contact">
                        <div className="dhara-terms-contact-title">Questions about these terms?</div>
                        <p className="dhara-terms-contact-text">
                            Contact us at legal@dhara.in or write to us at<br />
                            Dhara Atelier, 42 Hauz Khas Village, New Delhi 110016
                        </p>
                    </div>
                </div>
            </main>

            <Footer24 />
        </>
    );
};

export default TermsAndConditions24;
